/* eslint-disable css-modules/no-unused-class, css-modules/no-undef-class */

import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';

import { setRuntimeVariable } from '../../actions/runtime';

import iconLeft from './icon-arrow-left.svg';

import s from './HotelImagesGallery.css';

const galleryImageWidth = 97;

class HotelImagesGallery extends React.Component {
  static propTypes = {
    setRuntimeVariable: PropTypes.func,
    images: PropTypes.arrayOf(PropTypes.string),
  };

  static defaultProps = {
    setRuntimeVariable: () => {},
    images: [],
  };

  componentDidMount() {}

  componentWillUnmount() {}

  onClickControl = direction => {
    if (this.scrollPane) {
      const ratio = this.scrollPane.scrollLeft / galleryImageWidth;
      const round = Math.round(ratio);
      const gap = galleryImageWidth * (ratio - round);
      const elements = Math.round(
        this.scrollPane.offsetWidth / galleryImageWidth,
      );
      const destination =
        this.scrollPane.scrollLeft +
        direction * galleryImageWidth * elements -
        gap;
      this.animateScroll(destination);
    }
  };

  animateScroll = destination => {
    const easeInOutQuad = (t, b, c, d) => {
      let time = t / (d / 2);
      if (time < 1) return (c / 2) * time * time + b;
      time -= 1;
      return (-c / 2) * (time * (time - 2) - 1) + b;
    };
    if (this.scrollPane) {
      const duration = 0.5 * 1000;
      const start = this.scrollPane.scrollLeft;
      const diff = destination - start;
      let currentTime = 0;
      const framePerSecond = 60;
      const velocity = 1000 / framePerSecond;
      const animate = () => {
        currentTime += velocity;
        this.scrollPane.scrollLeft = easeInOutQuad(
          currentTime,
          start,
          diff,
          duration,
        );
        if (currentTime < duration) {
          setTimeout(animate, velocity);
        }
      };
      animate();
    }
  };

  render() {
    const { images } = this.props;
    const width = images.length * galleryImageWidth;
    const gallery = [];
    images.forEach((image, index) =>
      gallery.push(
        <li key={image}>
          <button
            onClick={() => {
              this.props.setRuntimeVariable({
                name: 'imageGallery',
                value: {
                  visible: true,
                  images,
                  currentIndex: index,
                },
              });
            }}
          >
            <img src={image} alt="Hotel" />
          </button>
        </li>,
      ),
    );
    return (
      <div className={s.root}>
        <button
          className={s.left}
          onClick={() => {
            this.onClickControl(-1);
          }}
        >
          <img src={iconLeft} alt="left" />
        </button>
        <div
          className={s.mask}
          ref={scrollPane => {
            this.scrollPane = scrollPane;
          }}
        >
          <ul style={{ width }}>{gallery}</ul>
        </div>
        <button
          className={s.right}
          onClick={() => {
            this.onClickControl(+1);
          }}
        >
          <img src={iconLeft} alt="right" />
        </button>
      </div>
    );
  }
}

const mapDispatch = {
  setRuntimeVariable,
};

export default connect(null, mapDispatch)(withStyles(s)(HotelImagesGallery));
